import { useState, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Home, Sidebar, Breadcrumb } from "../components";
import {
  Navigation,
  ConsignedOrder,
  Partners,
  EZDParameters,
  Products,
  sellableProduct,
  AccountBalance,
  MonthLocks,
  PaymentTerms,
  IngestionMonitor,
  RollabckIngestion,
  WSPartners
} from "../containers";
import Amplify from "@aws-amplify/core";
import Auth from "@aws-amplify/auth";
import { Hub } from "@aws-amplify/core";
import { actions as commonActions } from "../store/actions";
import { actions as sideBarActions } from "../containers/Sidebar/state/actions";
import { currentConfig } from "../auth/config/authConfig";
import { useDispatch } from "react-redux";
import { formattedUserGroups, setCookie } from "../utils/utils";
import Spinner from "../components/Spinner/Spinner";
// import SurveyEdit from "../containers/Survey/SurveyDetails/SurveyEdit";
import UnAuthorizedPage from "./../components/UnAuthorizedPage/UnAuthorizedPage";
import ProtectedRoutes from "../containers/ProtectedRoute/ProtectedRoutes";
import { useSelector } from "react-redux";
import "./styles.scss";
import Toaster from "../components/SnackBar/Toast";
import { getCookie } from "../utils/utils";
import SellableProduct from "../containers/SellableProduct/SellableProduct";

Amplify.configure(currentConfig);

const App = () => {
  const [toggleSidebar, settoggleSidebar] = useState(getCookie('sb') === 'true');
  const handleSidebarOpen = () => {
    setCookie('sb', !toggleSidebar);
    settoggleSidebar(!toggleSidebar);
  }
  const [activeSession, setActiveSession] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const commonState = useSelector((state) => state.common);
  const menuState = useSelector((state) => state.menus);
  const dispatch = useDispatch();

  useEffect(() => {
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "tokenRefresh":
          setActiveSession(false);
          getAuthSession();
          break;
        case "tokenRefresh_failure":
          console.log("token refresh failed");
          setActiveSession(false);
          Auth.federatedSignIn();
          break;
        case "cognitoHostedUI_failure":
          console.log("cognitoHostedUI_failure", data);
          break;
        default:
          console.log("event", event);
          break;
      }
    });
    getAuthSession();
  });


  const groups = commonState.userInfo?.userGroups || [];

  useEffect(() => {
    if (groups.length > 0 && !menuState?.data?.allowedMenus?.length) {
      // && (commonState.isCountryChanged || commonState.isCountryAvailable)) {
      dispatch(commonActions.setLoading(true));
      dispatch(sideBarActions.getMenus({ imdlGroups: groups.join(",")?.replace(/ /g, ""), companySk: commonState.userInfo?.companySk  }));
    }
  }, [commonState.userInfo?.userGroups]);
  // [commonState.userInfo?.userGroups, commonState.userInfo?.countrySk, commonState.isCountryAvailable]);

  const getAuthSession = async () => {
    try {
      let userInfo;
      if (!activeSession) {
        const session = await Auth.currentSession();
        const user = await Auth.currentUserInfo();
        userInfo = {
          principalName:
            user?.attributes["custom:userprincipalname"]?.split("@")[0] || "",
          userGroups: user?.attributes["custom:group"]
            ? formattedUserGroups(user?.attributes["custom:group"])
            : "",
          name: user?.attributes["name"]
        };

        dispatch(commonActions.setUserInfo(userInfo));
        setIsAuthenticated(true);
        setActiveSession(true);
      }
    } catch (error) {
      console.error("errrorrrr", error)
      setActiveSession(false);
      setIsAuthenticated(false);
      Auth.federatedSignIn();
    }
  };

  return (
    <div className="app">
      {isAuthenticated ? (
        <div className="app__main">
          {/* {groups.length > 0 ? ( */}
            <>
              <div className="app__left">
                <Sidebar toggleSidebarMenu={toggleSidebar} />
              </div>
              <div className="app__right">
                <Navigation handleSidebar={handleSidebarOpen} />
                <Breadcrumb />
                <Toaster />
                <Routes>
                  <Route path="/" exact element={<Home />} />
                  {/* <Route path="/products/add" exact element={<ProductsAdd />} />
                  <Route path="/products/:id" exact element={<ProductsEdit />} /> */}
                  <Route path="/consigned-order" exact element={
                    <ProtectedRoutes name="Consigned Order">
                      <ConsignedOrder />
                    </ProtectedRoutes>}
                  />
                  <Route path="/partners" exact element={
                    <ProtectedRoutes name="Partners">
                      <Partners />
                    </ProtectedRoutes>}
                  />
                  <Route path="/ezd-parameters" exact element={
                    <ProtectedRoutes name="EZD Parameters">
                      <EZDParameters />
                    </ProtectedRoutes>}
                  />
                  <Route path="/products" exact element={
                    <ProtectedRoutes name="Products">
                      <Products />
                    </ProtectedRoutes>}
                  />
                  <Route path="/sellable-product" exact element={
                    <ProtectedRoutes name="Products">
                      <SellableProduct />
                    </ProtectedRoutes>}
                  />
                  <Route path="/account-balance" exact element={
                    <ProtectedRoutes name="Account Balance">
                      <AccountBalance />
                    </ProtectedRoutes>}
                  />
                  <Route path="/month-lock" exact element={
                    <ProtectedRoutes name="Month Lock">
                      <MonthLocks />
                    </ProtectedRoutes>}
                  />
                  <Route path="/payment-terms" exact element={
                    <ProtectedRoutes name="Payment Terms">
                      <PaymentTerms />
                      </ProtectedRoutes>}
                  />
                  <Route path="/ingestion-monitor" exact element={
                    <ProtectedRoutes name="Ingestion Monitor">
                      <IngestionMonitor />
                    </ProtectedRoutes>}
                  />
                  <Route path="/rollback-ingestion" exact element={
                    <ProtectedRoutes name="Rollback Ingestion">
                      <RollabckIngestion />
                    </ProtectedRoutes>}
                  />
                  <Route path="/ws-partners" exact element={
                    <ProtectedRoutes name="WS/KA Partners">
                      <WSPartners />
                    </ProtectedRoutes>}
                  />
                  <Route path="/*" render={() => <Navigate replace to="/" />} />
                </Routes>
              </div>
            </>
          {/* <>
           ) : (
             <UnAuthorizedPage />
           )}
          </> */}
        </div>
       ) : (
        <div className="app__loading">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default App;
